<template>
  <v-app>
    <v-app-bar dense color="primary" app>
      <h2 class="white--text">PSD practice quiz</h2>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row
          justify="center"
          class="my-5 mx-4 text-subtitle-1"
          v-if="!startQuiz"
        >
          You can do a exam simulation with 80 questions or you can do the full
          quiz with 280 questions. In every case you will have 45 seconds per
          question. Good luck!
        </v-row>
        <div v-if="startQuiz">
          <Quiz :questionsNumber="questionsNumber" :shuffle="shuffle" />
        </div>
        <div v-else>
          <v-row justify="center" class="my-10">
            <v-btn
              color="primary"
              @click="
                shuffle = false;
                startQuiz = true;
              "
            >
              Start Quiz (All questions, no shuffle)
            </v-btn>
          </v-row>
          <v-row justify="center" class="my-10">
            <v-btn
              color="primary"
              @click="
                shuffle = true;
                startQuiz = true;
              "
            >
              Start Quiz (All questions, shuffled)
            </v-btn>
          </v-row>
          <v-row justify="center" class="my-10">
            <v-btn
              color="primary"
              @click="
                shuffle = true;
                questionsNumber = 80;
                startQuiz = true;
              "
            >
              Start Quiz (Exam simulation)
            </v-btn>
          </v-row>
        </div>
      </v-container>
    </v-main>
    <v-footer padless app color="primary">
        <v-col class="text-center white--text" cols="12">
          {{ new Date().getFullYear() }} —
          <strong>
            <a
              href="https://francescomoca.ml"
              target="_blank"
              class="white--text"
              >Francesco Moca
            </a></strong
          >
        </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Quiz from "./components/Quiz";

export default {
  name: "App",

  components: {
    Quiz,
  },

  data: () => ({
    startQuiz: false,
    questionsNumber: null,
    shuffle: null,
  }),
};
</script>

<style>
img {
  max-width: 100%;
}
</style>